import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import PerfectScrollbar from 'perfect-scrollbar';
import swal from 'sweetalert2';

declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
    userType: number;
    icon: object;
    active: string;
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
    path: '/users',
    title: 'Users',
    type: 'link',
    icon: {
        inactive: 'menu-users.svg',
        active: 'menu-users-dark.svg',
        size: {
            width: '22',
            height: '14'
        }
    },
    icontype: 'group',
    userType: 1,
    active: ''


}, {
    path: '/allsuggestions',
    title: 'Suggestions',
    type: 'link',
    icon: {
        inactive: 'menu-suggestions.svg',
        active: 'menu-suggestions-dark.svg',
        size: {
            width: '18',
            height: '18'
        }
    },
    icontype: 'photo',
    userType: 1,
    active: ''

}, {
    path: '/brands',
    title: 'Brands',
    type: 'link',
    icon: {
        inactive: 'menu-profile.svg',
        active: 'menu-profile-dark.svg',
        size: {
            width: '20',
            height: '14'
        }
    },
    icontype: 'local_bar',
    userType: 1,
    active: ''

}, {
    path: '/language',
    title: 'Language',
    type: 'link',
    icon: {
        inactive: 'menu-language.svg',
        active: 'menu-language-dark.svg',
        size: {
            width: '20',
            height: '20'
        }
    },
    icontype: 'language',
    userType: 1,
    active: ''
},
    {
        path: '/profile',
        title: 'Brand Profile',
        type: 'link',
        icon: {
            inactive: 'menu-profile.svg',
            active: 'menu-profile-dark.svg',
            size: {
                width: '20',
                height: '14'
            }
        },
        icontype: 'portrait',
        userType: 2,
        active: ''
    },
    {
        path: '/brandsuggestions',
        title: 'Brand Suggestions',
        type: 'link',
        icon: {
            inactive: 'menu-suggestions.svg',
            active: 'menu-suggestions-dark.svg',
            size: {
                width: '18',
                height: '18'
            }
        },
        icontype: 'photo',
        userType: 2,
        active: ''
    },

    {
        path: '/report',
        title: 'Suggestion Reporting',
        type: 'link',
        icon: {
            inactive: 'menu-reporting.svg',
            active: 'menu-reporting-dark.svg',
            size: {
                width: '20',
                height: '20'
            }
        },
        icontype: 'report',
        userType: 2,
        active: ''
    }, {
        path: 'Path',
        title: 'Log Out',
        type: 'link',
        icon: {
            inactive: 'menu-users.svg',
            active: 'menu-users-dark.svg',
            size: {
                width: '22',
                height: '14'
            }
        },
        icontype: 'backspace',
        userType: 1,
        active: ''

    }
];

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    public User_Details: any;

    constructor(
        public router: Router
    ) {
    }

    logOutUser() {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to log out?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            if (data.value) {
                console.log(this.router);
                localStorage.removeItem('Admin_User_Details');
                this.router.navigate(['/pages/login']);
            }

        })

    }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    ngOnInit() {

        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        this.menuItems = ROUTES.filter(menuItem => menuItem);

        if (this.User_Details.role.id != 1) {
            if (this.User_Details.Brands[0].is_parent == 1) {
                this.menuItems.unshift(
                    {
                        path: '/subbrandsuggestions',
                        title: 'Child Brands',
                        type: 'link',
                        icon: {
                            inactive: 'menu-child.svg',
                            active: 'menu-child-dark.svg',
                            size: {
                                width: '18',
                                height: '18'
                            }
                        },
                        icontype: 'photo',
                        userType: 2,
                        active: ''
                    })
            }
        }


        var route = this.router.url;
        console.log(route);

        for (var i = 0; i < this.menuItems.length; i++) {
            if (this.menuItems[i].path == route) {
                this.menuItems[i].active = 'active';
            }
        }

    }

    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            let ps = new PerfectScrollbar(elemSidebar, {wheelSpeed: 2, suppressScrollX: true});
        }
    }

    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }

    setActive(item) {
        for (var i = 0; i < this.menuItems.length; i++) {
            this.menuItems[i].active = '';
            if (this.menuItems[i].path == item.path) {
                this.menuItems[i].active = 'active';
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts